import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import Page from "components/page/Page";
import Card from "components/card/Card";
import Input from "components/form/input/Input";
import { StatusCode } from "api/protocols";

import { useTranslation, Trans } from "react-i18next";
import { PostModifierGroup } from "api/rpc/2024-04/facilityAdmin/product/modifier/modifierGroup";

interface IModifierState {
  title: string;
}

export default function ModifierGroupNew(props: any) {
  const history = useHistory();
  const { t, i18n } = useTranslation();
  const [modifierGroupState, setModifierGroupState] = useState<IModifierState>({
    title: "",
  });

  function handleInputChange(event: any) {
    const { id, value } = event.target;
    setModifierGroupState(prevState => ({ ...prevState, [id]: value }));
  }

  async function saveNewModifierGroup() {
    const res = await PostModifierGroup(modifierGroupState, true);
    if (res.status !== StatusCode.OK) {
      return;
    }

    history.push("/admin/settings/modifier_group");
  }

  const primaryAction = {
    content: t("Save"),
    action: saveNewModifierGroup,
  };

  return (
    <Page
      title={t("New Modifier Group")}
      narrow
      primaryAction={primaryAction}
      breadcrumbs={[
        {
          prefix: true,
          label: t("Modifier Groups"),
          url: "/admin/settings/modifier_group",
        },
      ]}
    >
      <Card>
        <Card.Section>
          <Input
            value={modifierGroupState.title}
            label={t("Title")}
            id="title"
            onChange={handleInputChange}
            placeholder={t("Title")}
          />
        </Card.Section>
      </Card>
    </Page>
  );
}
